import { render, staticRenderFns } from "./cam-rules.vue?vue&type=template&id=6bc74c83&scoped=true"
import script from "./cam-rules.vue?vue&type=script&lang=js"
export * from "./cam-rules.vue?vue&type=script&lang=js"
import style0 from "./cam-rules.vue?vue&type=style&index=0&id=6bc74c83&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc74c83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bc74c83')) {
      api.createRecord('6bc74c83', component.options)
    } else {
      api.reload('6bc74c83', component.options)
    }
    module.hot.accept("./cam-rules.vue?vue&type=template&id=6bc74c83&scoped=true", function () {
      api.rerender('6bc74c83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/help/help-rules/cam-rules.vue"
export default component.exports